export function masonry() {
	document.querySelectorAll('.expert-masonry').forEach((grid) => {
		Macy({
			container: grid,
			trueOrder: true,
			waitForImages: false,
			margin: 42,
			columns: 3,
			breakAt: {
				1024: 2,
				576: 1
			}
		});
	});
}